export enum ToastSeverityEnum {
  Info = "info",
  Success = "success",
  Warning = "warning",
  Error = "error"
}
